
/* ============================================================
   SmarterPaw Blog JS — article.js
   Add to: Assets > article.js
   Include before </body> in theme.liquid:
   {{ 'article.js' | asset_url | script_tag }}
   ============================================================ */

(function () {
  'use strict';

  /* ── FAQ Accordion ── */
  document.querySelectorAll('.sp-faq__question').forEach(function (btn) {
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var answer = this.nextElementSibling;
      this.setAttribute('aria-expanded', String(!expanded));
      answer.classList.toggle('is-open', !expanded);
    });
  });

  /* ── Reading Time ── */
  var body = document.querySelector('.sp-article__body');
  var metaReadingTime = document.querySelector('.sp-reading-time');
  if (body && metaReadingTime) {
    var words = body.innerText.trim().split(/\s+/).length;
    var minutes = Math.max(1, Math.round(words / 200));
    metaReadingTime.textContent = minutes + ' min read';
  }

  /* ── Smooth scroll for TOC links ── */
  document.querySelectorAll('.sp-toc a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── Sticky TOC highlight ── */
  var headings = document.querySelectorAll('.sp-article__body h2[id]');
  var tocLinks = document.querySelectorAll('.sp-toc a');
  if (headings.length && tocLinks.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          tocLinks.forEach(function (l) { l.classList.remove('is-active'); });
          var active = document.querySelector('.sp-toc a[href="#' + entry.target.id + '"]');
          if (active) active.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    headings.forEach(function (h) { observer.observe(h); });
  }

})();